import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import ProviderProfileService from '@/services/providerProfiles';
import store from '@/store';
// import timeSlotUtil from '@/utils/timeSlot';
import dateTimeUtil from '@/utils/dateTime';
import randomColor from 'randomcolor';
import moment from 'moment-timezone';
import { providerMixin } from '../../../transformers/providerProfile';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  mixins: [providerMixin],
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data: function () {
    return {
      calendarPlugins: [
        // plugins must be defined in the JS
        interactionPlugin,
        dayGridPlugin,
        timeGridPlugin,
        listPlugin,
      ],
      calendarWeekends: true,
      calendarEvents: [
        // initial event data
        // {title: 'Event Now', start: new Date()}
      ],
      headers: {
        left: 'prev,today,next',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
      },
      buttonText: {
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        listWeek: 'List Weeks',
      },
      // timeFormat: 'H(:mm)',
      validRange: {
        start: moment().startOf('month').format(),
        end: moment().add(9, 'week').day('Sunday').utc().format(),
      },
      defaultDate: moment().utc().format(),
      dataSchedule: {},
      views: {
        listWeek: { buttonText: 'list weeks' },
        dayGridMonth: {
          eventLimit: 3,
        },
        timeGridWeek: {
          columnHeaderFormat: {
            weekday: 'short',
            day: 'numeric',
          },
        },
      },
      eventTimeFormat: {
        // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: false,
        meridiem: false,
      },
      slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: false,
        meridiem: false,
      },

      providers: [],
      providerSelected: [],
      currentSelectedDate: null,
      isOpenDate: false,
      isOpenDateWeek: false,
      isOpenDateMonth: false,
      isRange: false,
      datePickerType: 'date',
      selectedNewDate: null,
      selectedNewMonth: null,
      selectedNewWeek: null,
      isShowEvent: false,
      selectedEventToDisplay: null,
      selectedListTitle: '',
      isShowEventList: false,
      selectedEventList: [],
      oldSelectedDate: null,
    };
  },
  computed: {
    user() {
      return store.state.auth.user;
    },
    calendarEvent() {
      return this.calendarEvents;
    },
    appointmentSchedule() {
      return this.$refs.fullCalendar.getApi();
    },
    providerOptions() {
      if (this.providers) {
        let provider = [];
        window._.map(this.providers, (val) => {
          const text = this.providerName(val);
          provider.push({
            text,
            value: val.id,
          });
        });
        return provider;
      } else return [];
    },
  },
  watch: {
    selectedNewDate() {
      this.goToDateCalender('day');
    },
    selectedNewMonth() {
      this.goToDateCalender('month');
    },
    selectedNewWeek(newV) {
      if (newV.length == 2) {
        this.goToDateCalender('week');
      }
    },
    providerSelected() {
      // console.log(newVal,val,window._.isEqual(window._.sortBy(newVal), window._.sortBy(val)))
      // this.setEventForProviderScheduleCalendar(newVal);
      this.getProviderschedule();
    },
  },
  methods: {
    viewSkeletonRender(info) {
      this.oldSelectedDate = this.currentSelectedDate;
      this.providerSelected = [];
      this.currentSelectedDate = {
        title: info.view.title,
        type: info.view.type,
      };
    },
    eventRender(info) {
      let startTime = moment(info.event.start).format('HH:mm');
      let endTime = moment(info.event.end).format('HH:mm');
      let temp = '';
      if (info.view.type == 'dayGridMonth') {
        temp = `<span class="fc-title"><div class="v-avatar popup_image"><img  src="${info.event.extendedProps.imageurl}"/></div>${info.event.title}</span>`;
        temp += `<span class="fc-time">${startTime + ' - ' + endTime}</span>`;
      } else if (info.view.type == 'timeGridDay') {
        temp = `<span class="fc-title d-flex"><div class="v-avatar popup_image"><img  src="${info.event.extendedProps.imageurl}"/></div><div class="titleDate_day">${info.event.title}</div></span>`;
        temp += `<div class="fc-time" data-full="${startTime + ' - ' + endTime}" data-start=${startTime}><span>${
          startTime + ' - ' + endTime
        }</span></div>`;
      } else {
        temp = `<span class="fc-title d-flex"><div class="v-avatar popup_image"><img  src="${info.event.extendedProps.imageurl}"/></div><div class="titleDate">${info.event.title}</div></span>`;
        temp += `<div class="fc-time" data-full="${startTime + ' - ' + endTime}" data-start=${startTime}><span>${
          startTime + ' - ' + endTime
        }</span></div>`;
        setTimeout(() => {
          let count = info.el.parentElement.childElementCount;
          if (
            info.el.parentElement &&
            info.el.parentElement.classList &&
            !info.el.parentElement.classList.contains(`event_parent${count}`)
          ) {
            info.el.parentElement.classList.add(`event_parent${count}`);
          }
        }, 500);
      }
      info.el.firstChild.innerHTML = temp;
    },
    clickedEvent(e) {
      this.isShowEvent = true;
      this.selectedEventToDisplay = {
        dateToDisplay: moment(e.event.start).format('DD MMMM YYYY'),
        title: e.event.title,
        timeToDisplay: moment(e.event.start).format('HH:mm') + ' - ' + moment(e.event.end).format('HH:mm'),
        imageurl: e.event.extendedProps.imageurl,
      };
    },
    datesRender(e) {
      if (this.oldSelectedDate && this.oldSelectedDate.type == e.view.type) {
        this.currentSelectedDate = {
          title: e.view.title,
          type: e.view.type,
        };
        this.oldSelectedDate = this.currentSelectedDate;
        this.getProviderschedule();
      } else {
        this.oldSelectedDate = this.currentSelectedDate;
      }
    },
    clickedDate(e) {
      this.selectedEventList = [];
      if (e.view.type == 'dayGridMonth') {
        this.selectedListTitle = moment(e.date).format('DD MMMM YYYY');
        this.calendarEvents.forEach((t) => {
          if (t.extendedProps.dateString == e.dateStr) {
            this.selectedEventList.push({
              title: t.title,
              timeToDisplay: moment(t.start).format('HH:mm') + ' - ' + moment(t.end).format('HH:mm'),
              imageurl: t.extendedProps.imageurl,
            });
          }
        });
        this.isShowEventList = true;
      }
    },
    getProviderschedule() {
      let ids = [...this.providerSelected];
      this.removeTitleClickEventListener();
      if (ids.length > 0 && this.currentSelectedDate) {
        let params = {
          ids: ids.join(','),
        };
        if (this.currentSelectedDate.type == 'timeGridDay') {
          params.date = moment(new Date(this.currentSelectedDate.title)).format('YYYY-MM-DD');
        } else if (this.currentSelectedDate.type == 'dayGridMonth') {
          params.month = new Date(this.currentSelectedDate.title).getMonth() + 1;
          params.year = new Date(this.currentSelectedDate.title).getFullYear();
        } else if (this.currentSelectedDate.type == 'timeGridWeek' || this.currentSelectedDate.type == 'listWeek') {
          let dateObj = { ...this.currentSelectedDate };
          dateObj.title = dateObj.title.split(' ');
          let month = isNaN(dateObj.title[dateObj.title.length - 2])
            ? dateObj.title[dateObj.title.length - 2]
            : dateObj.title[0]; // for uk length -2
          let date = isNaN(dateObj.title[dateObj.title.length - 2])
            ? dateObj.title[0]
            : dateObj.title[dateObj.title.length - 2];
          let tempDate = new Date(month + ' ' + date + ' ' + dateObj.title[dateObj.title.length - 1]);
          params.month = tempDate.getMonth() + 1;
          params.year = tempDate.getFullYear();
        }
        params.zone = dateTimeUtil.getLocalTimeZone();
        ProviderProfileService.fetchProviderSchedule(params).then((resData) => {
          let event = [];
          resData.data.forEach((providerD) => {
            providerD.schedules.forEach((schedule) => {
              const box = {
                id: providerD.id,
                title: `${providerD.firstname.en}  ${providerD.lastname.en}`,
                start: dateTimeUtil.formateDateTimeForDisplay(schedule.start, 'YYYY-MM-DD HH:mm'),
                end: dateTimeUtil.formateDateTimeForDisplay(schedule.end, 'YYYY-MM-DD HH:mm'),
                allDay: moment(schedule.end).diff(moment(schedule.start), 'hours') == 24 ? true : false,
                color: '#42A5F5',
                extendedProps: {
                  imageurl: providerD.avatar,
                  dateString: dateTimeUtil.formateDateTimeForDisplay(schedule.start, 'YYYY-MM-DD'),
                  type: this.currentSelectedDate.type,
                },
              };
              event.push(box);
            });
          });
          this.calendarEvents = event;
          this.titleClickEventListener();
        });
      } else {
        if (this.currentSelectedDate) {
          this.titleClickEventListener();
        }
        if (this.calendarEvents.length > 0) {
          this.calendarEvents = [];
        }
      }
    },
    color() {
      return randomColor({ luminosity: 'dark' });
    },
    toggleWeekends() {
      this.calendarWeekends = !this.calendarWeekends; // update a property
    },
    gotoPast() {
      let calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      calendarApi.gotoDate('2000-01-01'); // call a method on the Calendar object
    },
    handleDateClick(arg) {
      if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
        this.calendarEvents.push({
          // add new event data
          title: 'New Event',
          start: arg.date,
          allDay: arg.allDay,
        });
      }
    },
    remove(item) {
      const index = this.providerSelected.indexOf(item.id);
      if (index >= 0) this.providerSelected.splice(index, 1);
    },
    getProviderList() {
      return ProviderProfileService.all().then((data) => {
        if (data.data.length == data.pagination.total) {
          this.providers = data.data;
        } else {
          const params = {
            per_page: data.pagination.total,
            page: 1,
          };
          ProviderProfileService.all(params)
            .then((providerData) => {
              this.providers = providerData.data;
            })
            .catch((error) => {
              console.log(error);
            });
        }
        // data.forEach(provider => {
        //     provider.schedule = timeSlotUtil.scheduleList(provider, this.user.timezone);
        //     this.dataSchedule[provider.id] = provider;
        // })
        // this.providers = data.data;
        // console.log(this.providers);
      });
    },
    setEventForProviderScheduleCalendar(option = []) {
      const event = [];
      if (!option.length) {
        this.providers.forEach((provider) => {
          const schedules = provider.schedule;
          const color = this.color();
          for (const key in schedules) {
            // schedule each of provider
            let dates = schedules[key];
            for (let slot in dates) {
              const box = {
                id: provider.id,
                title: `${provider.firstname.en}  ${provider.lastname.en}`,
                start: moment(key + ' ' + dates[slot].startTime).toDate(),
                end: moment(key + ' ' + dates[slot].endTime).toDate(),
                data: dates,
                allDay:
                  moment(key + ' ' + dates[slot].endTime).diff(moment(key + ' ' + dates[slot].startTime), 'hours') == 24
                    ? true
                    : false,
                color: color,
              };
              // console.log(box)
              event.push(box);
            }
          }
        });
      } else {
        option.forEach((id) => {
          //each of provider
          const provider = this.dataSchedule[id];
          const schedules = provider.schedule;
          const color = this.color();
          for (const key in schedules) {
            // schedule each of provider
            let dates = schedules[key];
            for (let slot in dates) {
              const box = {
                id: provider.id,
                title: `${provider.firstname.en}  ${provider.lastname.en}`,
                start: moment(key + ' ' + dates[slot].startTime).toDate(),
                end: moment(key + ' ' + dates[slot].endTime).toDate(),
                data: dates,
                allDay:
                  moment(key + ' ' + dates[slot].endTime).diff(moment(key + ' ' + dates[slot].startTime), 'hours') == 24
                    ? true
                    : false,
                color: color,
              };
              // console.log(box)
              event.push(box);
            }
          }
        });
      }
      this.calendarEvents = event.filter(function (range) {
        return moment(range.start).isBefore(moment(range.end)) && moment(range.end).isAfter(moment(range.start));
      });
    },
    limitSelected() {
      if (this.providerSelected.length > 5) {
        this.providerSelected.pop();
      }
    },
    titleClickEventListener() {
      if (this.isOpenDate) {
        this.isOpenDate = false;
      }
      if (this.isOpenDateMonth) {
        this.isOpenDateMonth = false;
      }
      if (this.isOpenDateWeek) {
        this.isOpenDateWeek = false;
      }
      const ele = document.getElementsByClassName('fc-center');
      if (ele[0]) {
        ele[0].addEventListener('click', this.eventFunction);
      }
    },
    eventFunction() {
      if (this.currentSelectedDate.type == 'timeGridDay') {
        this.isOpenDate = !this.isOpenDate;
      } else if (this.currentSelectedDate.type == 'dayGridMonth') {
        this.isOpenDateMonth = !this.isOpenDateMonth;
      } else if (this.currentSelectedDate.type == 'timeGridWeek' || this.currentSelectedDate.type == 'listWeek') {
        this.isOpenDateWeek = !this.isOpenDateWeek;
      }
    },
    removeTitleClickEventListener() {
      const ele = document.getElementsByClassName('fc-center');
      if (ele[0]) {
        ele[0].removeEventListener('click', this.eventFunction);
      }
    },
    goToDateCalender(type) {
      let calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      if (type == 'day') {
        calendarApi.gotoDate(new Date(this.selectedNewDate));
      } else if (type == 'month') {
        calendarApi.gotoDate(new Date(this.selectedNewMonth));
      } else if (type == 'week') {
        calendarApi.gotoDate(new Date(this.selectedNewWeek[0]), new Date(this.selectedNewWeek[1]));
      }
    },
  },
  mounted() {
    // this.getProviderschedule();
    this.getProviderList();
  },
};
